import loadable from '@loadable/component'

export const Button = loadable(() => import('./Button'))
export type { ButtonProps } from './Button'
